import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from './environments/environment';

// Detect Playwright tests
// 1. Check user agent for Headless browsers
// 2. Check for Playwright-specific properties
const isPlaywright = /HeadlessChrome|Headless/.test(navigator.userAgent) ||
                     (window as any).__playwright !== undefined ||
                     navigator.webdriver === true;

Sentry.init({
    dsn: 'https://bccbbd886221995dcd601ad611206ab8@o1210468.ingest.us.sentry.io/4507254153347072',
    integrations: [
        // Registers and configures the Tracing integration,
        // which automatically instruments your application to monitor its
        // performance, including custom Angular routing instrumentation
        Sentry.browserTracingIntegration(),
        // Registers the Replay integration,
        // which automatically captures Session Replays
        Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    environment: environment.production ? 'production' : 'development',
    // Disable Sentry for Playwright tests
    enabled: environment.production && !isPlaywright,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/dev-kfp\.techcrowd\.space\.cz/, /^https:\/\/app\.kalkulackykfp\.cz/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Filter out known ApexCharts SVG matrix errors and icon loading errors
    beforeSend(event, hint) {
        const error = hint.originalException;
        if (error instanceof Error) {
            // Suppress ApexCharts SVG matrix errors
            if (error.message?.includes('SVGMatrix.inverse')) {
                return null;
            }
            // Suppress icon loading errors (missing SVG files)
            if (error.message?.includes('Loading icon set URL') || error.message?.includes('assets/icons/')) {
                console.warn('Icon loading error suppressed:', error.message);
                return null;
            }
        }
        return event;
    },
});

// Handle unhandled promise rejections (especially ApexCharts SVG matrix errors and icon loading errors)
window.addEventListener('unhandledrejection', event => {
    const error = event.reason;
    if (error instanceof Error) {
        // Suppress ApexCharts SVG matrix errors
        if (error.message?.includes('SVGMatrix.inverse')) {
            event.preventDefault();
            console.warn('ApexCharts SVG matrix error suppressed:', error);
            return;
        }
        // Suppress icon loading errors (missing SVG files)
        if (error.message?.includes('Loading icon set URL') || error.message?.includes('assets/icons/')) {
            event.preventDefault();
            console.warn('Icon loading error suppressed:', error.message);
            return;
        }
    }
});

platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
